import { render, staticRenderFns } from "./CommunityCompose.vue?vue&type=template&id=e8d9df7a&scoped=true&"
import script from "./CommunityCompose.vue?vue&type=script&lang=ts&"
export * from "./CommunityCompose.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCompose.vue?vue&type=style&index=0&id=e8d9df7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d9df7a",
  null
  
)

export default component.exports